import { Pipe, PipeTransform } from '@angular/core';
import { ToWords } from 'to-words';

@Pipe({
  name: 'aliasToolTip'
})
export class AliasToolTipPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (!value || value.length == 0) {
        return '';
    }
    
    const toWords = new ToWords();
    var arrayOfAlias = value.split("");
    let tooltipList = [];
    for (var i = 0; i < arrayOfAlias.length; i++) {
        if (!isNaN(arrayOfAlias[i])) {
            const Number = arrayOfAlias[i] + " = " + "Number" + " " +"(" + toWords.convert(arrayOfAlias[i]) + ")";
            tooltipList.push(Number);
        } else {
            const upperCase = arrayOfAlias[i].toUpperCase();
            const Str = arrayOfAlias[i] + " = " + "Letter" + " " +"(" + upperCase + ")";
            tooltipList.push(Str);
        }
    }
    return tooltipList;

}

}
